import { Outlet, useLocation } from 'react-router'
import { ErrorBoundary } from '@/components/ErrorBoundary'

/**
 * App-wide shell: renders the VONK signature background effects exactly once,
 * fixed behind all content, with the routed page on top via <Outlet/>. The base
 * gradient lives on <html> (see index.css) and shines through the effects.
 *
 * The routed area is wrapped in an {@link ErrorBoundary} (`resetKey` on the route
 * so navigating away from a crash recovers) — a crash in any page degrades to a
 * usable fallback instead of unmounting the SPA into an inescapable screen.
 * `resetKey` instead of a React `key`: a key would remount the whole subtree
 * (gates, sidebar, page) on every navigation, flashing the shell.
 */
export function RootLayout() {
  const location = useLocation()

  return (
    <div className="relative min-h-svh">
      <div className="fixed inset-0 -z-10">
        <div className="vonk-backgrounds">
          <div className="vonk-wave-gradient vonk-wave-gradient--primary" />
          <div className="vonk-wave-gradient vonk-wave-gradient--secondary" />
          <div className="vonk-ambient-sun" />
          <div className="vonk-ambient-orb" />
          <div className="vonk-flowing-lines">
            <span className="vonk-flowing-line" />
            <span className="vonk-flowing-line" />
            <span className="vonk-flowing-line" />
            <span className="vonk-flowing-line" />
          </div>
          <div className="vonk-curved-stripes">
            <span className="vonk-curved-stripe" />
            <span className="vonk-curved-stripe" />
            <span className="vonk-curved-stripe" />
            <span className="vonk-curved-stripe" />
            <span className="vonk-curved-stripe" />
          </div>
        </div>
      </div>
      <div className="relative z-0">
        <ErrorBoundary resetKey={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  )
}
